// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"ebda900c","198":"6eea273e","367":"1e3e1622","703":"523d75fe","787":"fe63cd4f","794":"80a79326","959":"4cfedd4f"}[chunkId] + ".chunk.js";
};